package streetlight.model.data

import kampfire.api.Markdown
import kampfire.api.Slug
import kampfire.model.GeoRect
import kampfire.model.GeoPoint
import kampfire.model.Labeled
import koala.Image
import koala.model.RouteContent
import kotlin.time.Instant
import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline
import kotlin.uuid.Uuid

/** A community of users around a place or a theme, with a feed of the posts its members share. */
@Serializable
data class Galaxy(
    val galaxyId: GalaxyId,
    val cityId: CityId?,
    val slug: Slug,
    val name: String,
    val tagline: String?,
    val description: Markdown?,
    val city: String?,
    override val geoPoint: GeoPoint,
    val geoRect: GeoRect,
    val postPermission: PostPermission,
    val reviewCount: Int,
    val postGuide: Markdown?,
    override val image: Image?,
    val design: PageDesign?,
    val isLit: Boolean,
    val isHost: Boolean,
    val starCount: Int,
    val eventCount: Int,
    val locationCount: Int,
    val postCount: Int,
    val updatedAt: Instant,
    override val createdAt: Instant,
): Entity, RouteContent {
    val postTypes get() = setOf(PostType.Location, PostType.Event, PostType.Media)
    override val label get() = name
    override val sublabel get() = tagline
    override val body get() = description
    override val markerId get() = galaxyId.toString()
}

@JvmInline @Serializable
value class GalaxyId(override val value: Uuid): RecordId {
    companion object { fun random() = GalaxyId(Uuid.random())}
    override fun toString() = value.toString()
}

/** Who may post to a galaxy. */
enum class PostPermission(label: String? = null): Labeled {
    Everyone,
    Accounts("Streetlight accounts"),
    Founder;

    override val label = label ?: name
}

/** The settings of a galaxy its hosts edit, with its marks. */
@Serializable
data class GalaxyConfig(
    val galaxy: Galaxy,
    val marks: List<GalaxyMark>
): RouteContent